/**
 * Estado de carga a pantalla completa para redirecciones y esperas de auth.
 *
 * POR QUÉ EXISTE: los redirects (RedirectToStore, RedirectToStorePath, DomainRouter) mostraban
 * "Redirigiendo..." con clases Tailwind (`min-h-screen`, `animate-spin`, `text-gray-600`). El panel
 * admin NO procesa Tailwind (es Polaris), así que esas clases NO se aplicaban: el spinner desaparecía
 * y quedaba el texto pelado arriba-izquierda — y encima aparecía "cuando había demora" (esperando el
 * tenant), leyéndose como un error. Este componente usa Polaris, que sí está disponible bajo el
 * AppProvider, y muestra solo un spinner centrado: se entiende como "cargando" sin la palabra que
 * asustaba.
 */
import { Box, Spinner } from '@/lib/polaris';

export function RedirectLoading() {
  return (
    <Box
      minHeight="100vh"
      width="100%"
      padding="800"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Spinner accessibilityLabel="Cargando" size="large" />
    </Box>
  );
}
